import { Actions } from '../actions/Actions';
import i18n from 'src/Locales/i18n';

const initialState = {
  language: i18n.language, // Default language
};
export const languageReducer = (state = initialState, action: any) => {
  switch (action.type) {
    case Actions.SET_LANGUAGE:
      return {
        ...state,
        language: action.payload,
      };
    default:
      return state;
  }
};

export default languageReducer;
